function mapObject(object, mapFunction) {
  return Object.getOwnPropertyNames(object).map((key) => mapFunction(key, object[key], object));
}
function mapRange(max, callbackfn) {
  const arr = [];
  for (let i = 0; i < max; ++i) {
    arr.push(callbackfn(i));
  }
  return arr;
}

export { mapRange as a, mapObject as m };
